import {
  Store,
  RevCenter,
  Payment,
  Employee,
  Column,
} from "@shared-ui-components/DataTable/types";
import { formatNumberWithCommaAndDollar } from "@src/constants";
import { getPropertyName } from "@utils/dataTableHelper";

// Constants
export const columns: Column[] = [
  { id: "name", label: "Store", minWidth: 145 },
  {
    id: "revenue",
    label: "Total Sales",
    minWidth: 103,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
];
export const filterOptions = [
  { label: "By Store", value: "store" },
  { label: "By Rev Center", value: "rvc" },
  { label: "By Payment Type", value: "pay" },
  { label: "By Employee", value: "emp" },
];

export const refineData = (
  data: Store[] | RevCenter[] | Payment[] | Employee[]
) => {
  if (data[0] !== null && data[0] !== undefined) {
    const keys = Object.keys(data["0"]);

    if (keys.includes("emp_first_name")) {
      const refined = data?.map((el: any) => {
        const refinedObject = {
          name: `${el.emp_first_name} ${el.emp_last_name}`,
          revenue: el.revenue,
          total: el.total,
        };
        return refinedObject;
      });
      return refined;
    }
    if (keys.includes("torinit_name")) {
      const refined = data?.map((el: any) => {
        const refinedObject = {
          name: el.torinit_name || el.oracle_name,
          revenue: el.revenue,
          total: el.total,
        };
        return refinedObject;
      });
      return refined;
    }
    const refined = data?.map((el: any) => {
      const refinedObject = {
        name: getPropertyName(el.property_short_name, el.name),
        revenue: el.revenue,
        total: el.total,
      };
      return refinedObject;
    });
    return refined;
  }
  return [];
};
